import gql from 'graphql-tag';

export const REBALANCE_TERRITORY_RULES = gql`
  mutation RebalanceTerritoryRules($input: RebalanceTerritoryInput!) {
    rebalanceTerritoryRules(input: $input) {
      success
    }
  }
`;
